/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Contact_Formattachment_Upload1Inputs */

const ja_contact_formattachment_upload1 = /** @type {(inputs: Contact_Formattachment_Upload1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`アップロードする`)
};

const en_contact_formattachment_upload1 = /** @type {(inputs: Contact_Formattachment_Upload1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Upload an attachment`)
};

/**
* | output |
* | --- |
* | "Upload an attachment" |
*
* @param {Contact_Formattachment_Upload1Inputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
const contact_formattachment_upload1 = /** @type {((inputs?: Contact_Formattachment_Upload1Inputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Contact_Formattachment_Upload1Inputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ja") return ja_contact_formattachment_upload1(inputs)
	return en_contact_formattachment_upload1(inputs)
});
export { contact_formattachment_upload1 as "contact_formAttachment_upload" }